import { Configuration } from '@azure/msal-browser';
import { AZURE_AD_CLIENT_ID, TENANT_URL } from '../react-app-env.d';

const currentHost = window.location.hostname;
const redirectUri = currentHost.includes('localhost')
  ? `${window.location.origin}/`
  : `https://${currentHost}/`;
// const redirectUriMap: Record<string, string> = {
//   'cilantro.mycompass.co.in': 'https://cilantro.mycompass.co.in/',
//   'cilantrouat.mycompass.co.in': 'https://cilantrouat.mycompass.co.in/',
//   'qa-cilantro-frontend.azurewebsites.net': 'https://qa-cilantro-frontend.azurewebsites.net/',
//   'dev-cilantro-frontend.azurewebsites.net': 'https://dev-cilantro-frontend.azurewebsites.net/'
// };

export const msalConfig: Configuration = {
  auth: {
    clientId: AZURE_AD_CLIENT_ID,
    authority: TENANT_URL,
    redirectUri: redirectUri
    // redirectUri: Object.entries(redirectUriMap).find(([key]) => currentHost.includes(key))?.[1] || 'http://localhost:3000' // Fallback for localhost
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      // loggerCallback: (level, message, containsPii) => {
      //   if (containsPii) {
      //     return;
      //   }
      //   switch (level) {
      //     case LogLevel.Error:
      //       console.error(message);
      //       return;
      //     case LogLevel.Info:
      //       console.info(message);
      //       return;
      //     case LogLevel.Verbose:
      //       console.debug(message);
      //       return;
      //     case LogLevel.Warning:
      //       console.warn(message);
      //       return;
      //   }
      // },
    },
  },
};
